import { Auth } from '@aws-amplify/auth'
import { Investor } from '@tumelo/shared'
import { InvestorService } from './InvestorService'

const FINISHED_ONBOARDING_ATTRIBUTE = 'custom:finished_onboarding'
const INVESTOR_ID_ATTRIBUTE = 'custom:investor_id'

export const InvestorServiceCognito: InvestorService = {
  async setFinishedOnboarding(finishedOnboarding: boolean): Promise<Investor> {
    const user = await Auth.currentAuthenticatedUser()
    await Auth.updateUserAttributes(user, { [FINISHED_ONBOARDING_ATTRIBUTE]: finishedOnboarding ? 'true' : 'false' })
    return this.getInvestor()
  },
  async getInvestor(): Promise<Investor> {
    const { attributes } = await Auth.currentUserInfo()
    return {
      sub: attributes.sub,
      investorId: attributes[INVESTOR_ID_ATTRIBUTE],
      firstName: attributes.given_name,
      lastName: attributes.family_name,
      email: attributes.email,
      // If signed in via federated sign in, the CognitoUser will have an array of identities
      signedInWithSSO: {}.hasOwnProperty.call(attributes, 'identities'),
      changeEmail: {
        emailVerified: attributes.email_verified,
      },
      preferences: {
        finishedOnboarding: attributes[FINISHED_ONBOARDING_ATTRIBUTE],
      },
      nickname: attributes.nickname,
    }
  },
  async deleteInvestor(): Promise<void> {
    const user = await Auth.currentAuthenticatedUser()
    await new Promise<void>((resolve, reject) => {
      user.deleteUser((err: any) => {
        if (err) {
          reject(new Error(`Failed to delete Cognito User: ${err}`))
        }
      })
      resolve()
    })
  },
  async updateInvestorEmail(email: string): Promise<void> {
    await Auth.currentAuthenticatedUser()
      .then(async (user) => {
        await new Promise<void>((resolve, reject) => {
          Auth.updateUserAttributes(user, { email })
            .then(async () => {
              await Auth.currentAuthenticatedUser({ bypassCache: true })
              resolve()
            })
            .catch((error) => {
              reject(error)
            })
        })
      })
      .catch((error) => {
        throw error
      })
  },
  async updateInvestorNickname(nickname: string): Promise<Investor> {
    return Auth.currentAuthenticatedUser()
      .then(async (user) => {
        return Auth.updateUserAttributes(user, { nickname }).then(async () => this.getInvestor())
      })
      .catch((error) => {
        throw error
      })
  },
}
